import {
    DataLayerEventName,
    LiveBlogEvents,
    Product,
    SharingEvent,
    WebLink,
} from '@news-mono/web-common'
import React, { FC, useState } from 'react'
import {
    StyledMilestone,
    StyledMilestonesContainer,
    StyledMilestonesTimeline,
    StyledMilestonesTitle,
    StyledMilestoneTimestamp,
    StyledMilestoneTitle,
} from './LiveEventMilestones.styled'
import { TruncatingContainer } from './utility/TruncatingContainer'
import { useTheme } from '@emotion/react'
import { calcRem } from '../../../__styling'
import { StyledMobilePaddingContainer } from '../../../templates/Publication/TheNightlyPublication/TheNightlyPublication.styled'
import { ConditionalWrapper } from '../../../__helpers/ConditionalWrapper'
import { TNLiveComponent } from '../../../content'
import { EventPostV4DTO } from '@west-australian-newspapers/publication-types'
import { TNLiveBlogMilestones } from '../../../cards/LiveBlogs/components/TNLiveBlogMilestones'
import { CardLinkWrapper } from '../../../cards/TheNightly/ListCard/ListCard.styled'

function transformUrl(url: string): string {
    const parsedUrl = new URL(url)
    return parsedUrl.pathname + parsedUrl.hash
}
export interface LiveEventMilestonesProps {
    milestones: EventPostV4DTO[]
    enableTruncation?: boolean
    onEvent: (event: LiveBlogEvents | SharingEvent) => void
    isActiveEvent?: boolean
}

export const LiveEventMilestones: FC<LiveEventMilestonesProps> = ({
    milestones,
    onEvent,
    isActiveEvent = false,
}) => {
    const [dimMilestones, setDimMilestones] = useState(false)
    const theme = useTheme()
    const isTheNightly = theme.kind === Product.TheNightly

    return (
        //add padding to thenightly blocks to offset the luna container
        <ConditionalWrapper
            condition={isTheNightly}
            Wrapper={({ children }) => (
                <StyledMobilePaddingContainer>
                    {children}
                </StyledMobilePaddingContainer>
            )}
        >
            {isTheNightly && isActiveEvent && (
                <TNLiveComponent padding={calcRem(18, 0, 0)} />
            )}
            <TruncatingContainer customStyle={'milestones'}>
                {isTheNightly ? (
                    <TNLiveBlogMilestones
                        posts={milestones
                            .filter(
                                (m) => m.title != null && m.title.trim() !== '',
                            )
                            .map((m) => ({
                                postId: m.id,
                                title: m.title as string,
                                link: transformUrl(m._self),
                                publishedDate: m.publishedDate,
                            }))}
                        getLinkComponentWithChildren={(props) => (
                            <CardLinkWrapper
                                {...props}
                                openExternalInNewWindow={false}
                            />
                        )}
                        showHeader={true}
                        showDateTime={true}
                    />
                ) : (
                    <StyledMilestonesContainer>
                        <StyledMilestonesTitle>
                            Key Events
                        </StyledMilestonesTitle>
                        <StyledMilestonesTimeline>
                            {milestones.map((m) => (
                                <WebLink key={m.id} to={transformUrl(m._self)}>
                                    <StyledMilestone
                                        dimmed={!isTheNightly && dimMilestones}
                                        onMouseEnter={() =>
                                            setDimMilestones(true)
                                        }
                                        onMouseLeave={() =>
                                            setDimMilestones(false)
                                        }
                                        onClick={() => {
                                            onEvent({
                                                type: DataLayerEventName.milestoneClick,
                                                originator: 'LiveEvent',
                                                payload: {
                                                    publicationId: m.eventId,
                                                    postId: m.id,
                                                },
                                            })
                                        }}
                                    >
                                        <StyledMilestoneTimestamp
                                            timestampStyle="relative"
                                            time={m.publishedDate}
                                        />
                                        <StyledMilestoneTitle>
                                            {m.title}
                                        </StyledMilestoneTitle>
                                    </StyledMilestone>
                                </WebLink>
                            ))}
                        </StyledMilestonesTimeline>
                    </StyledMilestonesContainer>
                )}
            </TruncatingContainer>
        </ConditionalWrapper>
    )
}
